import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

registerLocaleData(localeFr, 'fr-FR');
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { withFetch } from '@angular/common/http';

import { MessageService } from 'primeng/api';
import { NotificationMessageService } from './shared/services/notification-message.service';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { jwtInterceptor } from './shared/auth/interceptors/jwt.interceptor';
import { errorInterceptor } from './shared/auth/interceptors/error.interceptor';


//import { themeConfig } from './primeng-theme';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, 
      withInMemoryScrolling({
        scrollPositionRestoration: 'disabled'
      })
    ),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      })
    ),
  provideHttpClient(withFetch(), withInterceptors([errorInterceptor, jwtInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
             theme: {
                 preset: Aura
            }
       }),
    { provide: MessageService, useClass: NotificationMessageService },
    { provide: LOCALE_ID, useValue: 'fr-FR' }
  ]
};
